module.exports = __webpack_public_path__ + "d13a3baf03897e40f1e35ae57b082fb7.jpg";